import { Injectable } from "@angular/core";
import { Observable, BehaviorSubject } from "rxjs";
import { Http } from "@angular/http";
import * as lodash from "lodash";
import {
    SERVICE_URLS,
    TCITenantAppType,
    ITCISupplementServiceProvider,
    ITCISupplement,
    TCITenantEnvToolsSupplements,
    ITCITenantSupplementRequest,
    ITCISupplementConnector,
    TCITenantEnvTools,
    ITCITenantSupplementResponse,
    mapIServiceToTenantAppType
 } from "@tci/common";
 import { TciTenantService } from "../../ng-tenant/tci-tenant.service";
 import { TciTenantModelService } from "../../ng-tenant/tci-tenant.model";
import { TCITenantRemoteServices } from "../../ng-tenant/tci-tenant-remote-services";
import { NgUserService } from "../../ng-shared/ng-services/ng-user.service";
import { BaseEnvToolsSupplementMenuComponentInput } from "./base-supplement-menu/base-supplement-menu";
import { NgAppFeatureToggleService } from "../../ng-shared/ng-services/ng-app-feature-toggle.service";
import { TCITenantMenuServices } from "../../ng-tenant/tci-tenant.menu";

export interface ISupplementsMenuOpts {
    supplement: ITCISupplement;
    comps: TCITenantEnvToolsSupplements[];
}
@Injectable()
export class BaseSupplementListService {
    statusMenuOptions$: BehaviorSubject<ISupplementsMenuOpts[]> = new BehaviorSubject([]);

    constructor(
        private http: Http,
        private tenantRemoteSvc: TCITenantRemoteServices,
        private tenantSvc: TciTenantService,
        private tenantModelSvc: TciTenantModelService,
        private userSvc: NgUserService,
        private featureToggleSvc: NgAppFeatureToggleService,
        private tenantMenuSrv: TCITenantMenuServices
        ) {
    }

    public getSupplements(): Observable<ITCISupplement[]> {
        return this.getProviders()
            .flatMap(providers => {
                const tenantSupplementsObs = providers.map(provider => provider.getSupplements());
                return Observable.merge(...tenantSupplementsObs)
                    .toArray()
                    .map(suppArr => lodash.flatten(suppArr))
                    .map(suppArr => {
                        // HM menu not supported in this release.
                        // this.setStatusMenuOptions(suppArr);
                        return suppArr;
                    });
            });
    }

    public getConnectorList(tenantType: TCITenantAppType): Observable<ITCISupplementConnector[]> {
        return this.getTenantProvider(tenantType)
            .flatMap(provider => {
                if (provider) {
                    return provider.getAllSupplementConnectors({tenantType: tenantType})
                        .toArray()
                        .map(connArr => lodash.flatten(connArr) as ITCISupplementConnector[]);
                } else {
                    console.error("No supplement provider for tenant :", tenantType);
                    return Observable.of([]);
                }
            });
    }

    public uploadSupplement(suppCreateInfo: ITCITenantSupplementRequest): any {

        return this.getTenantProvider(suppCreateInfo.tenantType)
            .flatMap(provider => {
                if (provider) {
                   return provider.createSupplement(suppCreateInfo)
                    .map(res => res);
                } else {
                    console.error("No supplement provider for tenant :", suppCreateInfo.tenantType);
                }
            });
    }

    public getSupplementStatus(provider: ITCISupplementServiceProvider): Observable<ITCITenantSupplementResponse> {
        if (provider) {
            return provider.getStatusSubject();
        } else {
            console.error("No supplement provider for getting upload status");
            return Observable.of(<ITCITenantSupplementResponse>{
                success: false,
                msg: "No supplement provider for getting upload status."
            });
        }
    }

    private getTenantProvider(tenantType: TCITenantAppType): Observable<ITCISupplementServiceProvider> {
        return this.tenantSvc.onInit()
        .flatMap((res) => {
            const tenant = this.tenantModelSvc.getTenant(tenantType);
            if (tenant) {
                const provider = tenant.getSupplementServiceProvider();
                if (provider) {
                    return Observable.of(provider);
                }
                return Observable.of(null);
            }
        });
    }

    private getProviders(): Observable<ITCISupplementServiceProvider[]> {
        return this.getCurrentRemoteServices()
            .map(types => types
                .map(type => this.tenantModelSvc.getTenant(type))
                .filter(tenantProvider => !!tenantProvider)
                .map(tenantProvider => tenantProvider.getSupplementServiceProvider())
                .filter(tenantProviderSvc => !!tenantProviderSvc)
            );
    }

    // Status Menu Methods
    private setStatusMenuOptions(supplements: ITCISupplement[]): void {
        const obsCollection: Observable<ISupplementsMenuOpts>[] = [];

        TCITenantEnvToolsSupplements.getAllMenuItems().map(menuItem => {
        supplements
            .map(supplement => {
                const input = new BaseEnvToolsSupplementMenuComponentInput(
                    this.userSvc,
                    this.featureToggleSvc,
                    menuItem
                );

                obsCollection.push(
                    this.tenantMenuSrv
                        .getEnvToolsSupplementsMenuItems(
                            menuItem,
                            input
                    )
                        .map((comps: TCITenantEnvToolsSupplements[]) => ({ supplement: supplement, comps: comps || [] }))
                    );
                });
            });

        Observable.merge(...obsCollection)
            .distinct()
            .toArray()
            .subscribe(res => this.statusMenuOptions$.next(res));
    }

    // For IPAS-16407
    getCurrentRemoteServices(): Observable<TCITenantAppType[]> {
        return this.tenantSvc.onInit()
            .flatMap(() => this.tenantRemoteSvc.getRemoteServices())
            .map(svcs => svcs.map(svc => mapIServiceToTenantAppType(svc)));
    }
}
